// extracted by mini-css-extract-plugin
export default {"timeline":"style_timeline__pZZpv","timelineEvent":"style_timelineEvent__OOvBm","date":"style_date__Aek5-","description":"style_description__gjPlM"};